
document.addEventListener('alpine:init', () => {

  Alpine.store('global', FWS.Cart.createGlobalStore())

  Alpine.data('tooltip', (opts={}) => ({
    open: false,
    init() {
      this.$root.classList.add('tooltip')
      this.$root.classList.add(`tooltip-${opts.align || 'left'}`)
      this.$root.classList.add(`tooltip-${opts.alignY || 'top'}`)
      this.$root.classList.add(`text-${opts.text || 'left'}`)
    },
    clickTrigger: {
      ['@click.prevent']() {
        this.open = !this.open
      }
    },
    trigger: {
      ['@mouseover']() {
        this.open = true
      },
      ['@mouseout']() {
        this.open = false
      }
    }
  }))
})
